import {AMP, OP_B1, OP_B2, OP_A, FILTER, PITCH, MODULATION} from 'constants/envelope-types.js';

export const ENVELOPE_OPTIONS = [
    {value: AMP, label: 'Amp'},
    {value: OP_A, label: 'Op. A'},
    {value: OP_B1, label: 'Op. B1'},
    {value: OP_B2, label: 'Op. B2'},
    {value: FILTER, label: 'Filter'},
    {value: PITCH, label: 'Pitch'},
];

